// Avatar simplu bazat pe inițiala numelui, cu o culoare pastel
// generată în funcție de nume (același nume -> aceeași culoare).

const CULORI = [
  "bg-emerald-100 text-emerald-700",
  "bg-sky-100 text-sky-700",
  "bg-amber-100 text-amber-700",
  "bg-rose-100 text-rose-700",
  "bg-violet-100 text-violet-700",
  "bg-teal-100 text-teal-700",
  "bg-orange-100 text-orange-700",
  "bg-indigo-100 text-indigo-700",
];

function culoarePentruNume(nume) {
  let suma = 0;
  for (let i = 0; i < nume.length; i++) {
    suma += nume.charCodeAt(i);
  }
  return CULORI[suma % CULORI.length];
}

const marimi = {
  sm: "h-8 w-8 text-xs",
  md: "h-10 w-10 text-sm",
  lg: "h-12 w-12 text-base",
};

export function Avatar({ name, size = "md" }) {
  const initiala = name ? name.charAt(0).toUpperCase() : "?";
  return (
    <div
      className={`flex items-center justify-center rounded-full font-bold shrink-0 ${culoarePentruNume(
        name
      )} ${marimi[size]}`}
      data-testid={`avatar-${name}`}
    >
      {initiala}
    </div>
  );
}
